import useAdminSettingsQuery from '@/features/app/queries/useAdminSettingsQuery';
import { BarChartOutlined, MailOutlined, SyncOutlined, UserOutlined } from '@ant-design/icons';
import { cx as classNames } from '@emotion/css';
import { IconGear } from '@thisisdmg/tirecloud-patterns';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useFeatureFlags from '@/features/feature-flags/hooks/useFeatureFlags';

const commonClassName =
  'tw:border-0 tw:border-b tw:border-solid tw:border-[rgba(224,224,224,0.45)] tw:py-(--spacing-6)';

export function useAdminSideMenu(firstChildBorderTop = false) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: adminSettings } = useAdminSettingsQuery();
  const featureFlags = useFeatureFlags();

  return useMemo(
    () =>
      [
        {
          key: '/admin/analytics',
          label: t('component.header.adminMenu.analytics'),
          icon: <BarChartOutlined />,
          className: classNames(commonClassName, firstChildBorderTop ? 'tw:border-t' : ''),
          onClick: () => {
            navigate('/admin/analytics');
          },
          enabled: featureFlags.page.admin.analytics.enabled,
        },
        {
          key: '/admin/analytics/user',
          label: t('component.header.adminMenu.userBehavior'),
          icon: <BarChartOutlined />,
          className: classNames(commonClassName),
          onClick: () => {
            navigate('/admin/analytics/user');
          },
          enabled: featureFlags.page.admin.analytics.enabled,
        },
        {
          key: '/admin/users',
          label: t('component.header.adminMenu.users'),
          icon: <UserOutlined />,
          className: classNames(commonClassName),
          onClick: () => {
            navigate('/admin/users');
          },
          enabled: featureFlags.page.admin.userManagement.enabled,
        },
        {
          key: '/admin/dashboard-settings',
          label: t('component.header.adminMenu.dashboardSettings'),
          icon: (
            <span>
              <IconGear size={14} />
            </span>
          ),
          className: classNames(commonClassName),
          onClick: () => {
            navigate('/admin/dashboard-settings');
          },
          enabled: featureFlags.page.admin.dashboardSettings.enabled,
        },
        {
          key: '/admin/email-settings',
          label: t('component.header.adminMenu.emailSettings'),
          icon: (
            <span>
              <MailOutlined size={14} />
            </span>
          ),
          className: classNames(commonClassName),
          onClick: () => {
            navigate('/admin/email-settings');
          },
          enabled: featureFlags.page.admin.emailSettings.enabled,
        },
        {
          key: '/admin/import-export-settings',
          label: t('component.header.adminMenu.importExportSettings'),
          icon: (
            <span>
              <SyncOutlined size={14} />
            </span>
          ),
          className: classNames(commonClassName),
          onClick: () => {
            navigate('/admin/import-export-settings');
          },
          enabled: featureFlags.page.admin.importExportSettings.enabled,
        },
      ].filter((item) => item.enabled),
    [adminSettings, firstChildBorderTop, navigate, t]
  );
}
